import type { Database } from 'sql.js';
import type { LocalCatalogCounts } from '@src/modules/kernel/LocalCatalogCounts.ts';
import { EMPTY_LOCAL_CATALOG_COUNTS } from '@src/modules/kernel/LocalCatalogCounts.ts';
import type { GetSqlJsDatabase } from './sqlJsRowHelpers.ts';

function readActiveCount(db: Database, table: 'items_entrega' | 'productos_reposicion' | 'medios_reporte' | 'motivos_reposicion'): number {
  const stmt = db.prepare(`SELECT COUNT(*) AS n FROM ${table} WHERE estado = 1`);
  stmt.step();
  const row = stmt.getAsObject() as Record<string, unknown>;
  stmt.free();
  const n = Number(row.n);
  return Number.isFinite(n) ? n : 0;
}

export function queryLocalCatalogCounts(getDb: GetSqlJsDatabase): LocalCatalogCounts {
  const db = getDb();
  if (!db) return { ...EMPTY_LOCAL_CATALOG_COUNTS };
  try {
    return {
      itemsEntrega: readActiveCount(db, 'items_entrega'),
      productosReposicion: readActiveCount(db, 'productos_reposicion'),
      mediosReporte: readActiveCount(db, 'medios_reporte'),
      motivosReposicion: readActiveCount(db, 'motivos_reposicion'),
    };
  } catch {
    return { ...EMPTY_LOCAL_CATALOG_COUNTS };
  }
}
